import { useState, useEffect } from 'react';
import { getMyActiveRally } from '../../services/ghostRallyService';
import GhostRallyActive from '../clubs/ghost-rally/GhostRallyActive';

/**
 * Slim banner at the top of the home dashboard. Shows a shortcut into the
 * live rally view whenever the user is currently checked in or active in
 * a Ghost Rally with status='active'. Renders nothing otherwise — safe to
 * drop in unconditionally.
 */
export default function DashboardGhostRallyBanner({ onToast }) {
  const [rally, setRally] = useState(null); // { rally_id, event_id, title, rally_status, my_status, official_start_time }
  const [open, setOpen] = useState(false);

  useEffect(() => {
    let alive = true;
    (async () => {
      const { data } = await getMyActiveRally();
      if (!alive) return;
      setRally(data);
    })();
    return () => { alive = false; };
  }, []);

  if (!rally) return null;

  const waiting = rally.my_status === 'checked_in';
  const label = waiting ? '⏳ Waiting for Start' : '🚗 Open Rally — Live';

  async function refresh() {
    const { data } = await getMyActiveRally();
    setRally(data);
  }

  return (
    <>
      <div
        onClick={() => setOpen(true)}
        style={{
          display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12,
          background: 'linear-gradient(135deg, #7c3aed 0%, #a78bfa 100%)',
          borderRadius: 'var(--radius-md, 8px)',
          padding: '12px 14px',
          marginBottom: 16,
          cursor: 'pointer',
          boxShadow: '0 2px 8px rgba(124,58,237,0.25)',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, minWidth: 0, flex: 1 }}>
          <span style={pill}>👻 Ghost Rally</span>
          <div style={{ minWidth: 0 }}>
            <div style={{ fontSize: '0.875rem', fontWeight: 700, color: '#fff', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
              {rally.title || 'Ghost Rally'}
            </div>
            <div style={{ fontSize: '0.75rem', color: 'rgba(255,255,255,0.8)' }}>
              {label}
            </div>
          </div>
        </div>
        <div style={{ fontSize: '1.125rem', color: '#fff', flexShrink: 0 }}>›</div>
      </div>

      {open && (
        <GhostRallyActive
          eventId={rally.event_id}
          onClose={() => { setOpen(false); refresh(); }}
          onToast={onToast}
        />
      )}
    </>
  );
}

const pill = {
  fontSize: '0.6875rem', fontWeight: 700, letterSpacing: 0.3,
  padding: '4px 9px', borderRadius: 4,
  background: 'rgba(0,0,0,0.25)', color: '#fff',
  flexShrink: 0,
};
